import { render, staticRenderFns } from "./ResultsTable.vue?vue&type=template&id=377276e0&scoped=true"
import script from "./ResultsTable.vue?vue&type=script&lang=js"
export * from "./ResultsTable.vue?vue&type=script&lang=js"
import style0 from "./ResultsTable.vue?vue&type=style&index=0&id=377276e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377276e0",
  null
  
)

export default component.exports